<div class="cart-wizard-shell card">
    <aw-wizard class="wizard-design shop-wizard cart-wizard">
        <form class="cart-wizard__form" [formGroup]="cartForm">
            <aw-wizard-step (stepEnter)="onStepEnter($event,CART_STEPS.BundleDetails);" class="cart-wizard__step cart-wizard__step--placeholder" [stepTitle]="'PRODUCTS_STEP' | translate"></aw-wizard-step>

            <aw-wizard-step (stepEnter)="onStepEnter($event,CART_STEPS.RequiredInfo)" class="cart-wizard__step" [stepTitle]="'LOCATION' | translate">
                <div class="cart-wizard__surface" *ngIf="!requiredInfoCompleted">
                    <div fxLayout="column">
                        <div *ngIf="!isOptionSelected">
                            <app-campaign-selection
                                [userRoles]="userRoles"
                                [clientsData]="clientsData"
                                [selectedClient]="selectedClient"
                                [finalizedProducts]="finalizedProducts"
                                [addingFacebook]="addingFacebook"
                                [addingGoogle]="addingGoogle"
                                [addingConsulting]="addingConsulting"
                                [addingNational]="addingNational"
                                (campaignSelected)="selectedCampaign($event.clientId, $event.campaign, $event.campaignId)"
                                (clientChange)="onChangeClient($event)"
                                (newCampaign)="onNewCampaign($event)">
                            </app-campaign-selection>
                        </div>
                        <div *ngIf="isNewCampaign" class="card card-custom cart-wizard__subsurface">
                            <app-new-campaign-form
                                [campForm]="campForm"
                                [clientsData]="clientsData"
                                [selectedClient]="selectedClient"
                                [addingFacebook]="addingFacebook"
                                (changeCampaign)="onNewCampaign($event)"
                                (changeClient)="onChangeClient($event)"
                                (submitCampForm)="onCampFormSubmit($event)">
                            </app-new-campaign-form>
                        </div>
                    </div>
                </div>
                <div class="cart-wizard__surface cart-wizard__surface--message" *ngIf="requiredInfoCompleted">
                    <div fxLayout="column">
                        <p class="cart-wizard__message-title">{{ 'NO_INFORMATION_IS_REQUIRED_FOR_THIS_PRODUCT' | translate }}</p>
                        <p class="cart-wizard__message-copy">{{ 'YOU_CAN_CONTINUE_DIRECTLY_TO_THE_NEXT_STEP' | translate }}</p>
                        <div class="cart-wizard__divider-shell">
                            <hr>
                        </div>
                        <div class="cart-wizard__message-actions" fxLayout="row" fxLayoutAlign="space-between center">
                            <button type="button" class="btn btn-page"
                                (click)="onPrevious(CART_STEPS.BundleDetails)">{{ 'BACK' | translate }}</button>
                            <button type="button" (click)="onNext(CART_STEPS.RequiredInfo)"
                                class="btn btn-page">{{ 'NEXT' | translate }}</button>
                        </div>
                    </div>
                </div>
            </aw-wizard-step>

            <aw-wizard-step class="cart-wizard__step" [stepTitle]="'AD_SPEND' | translate" (stepEnter)="onStepEnter($event,CART_STEPS.Cart)">
                <app-ad-spend *ngIf="activeCart.currentStep === CART_STEPS.Cart"
                    [finalizedProducts]="finalizedProducts"
                    [addingFacebook]="addingFacebook"
                    [addingGoogle]="addingGoogle"
                    [hasFacebook]="hasFacebook"
                    [hasGoogle]="hasGoogle"
                    [cartForm]="cartForm"
                    [stepsData]="stepsData"
                    [productAdSpendOptions]="productAdSpendOptions"
                    (previous)="onPrevious(CART_STEPS.RequiredInfo)"
                    (continue)="continueToCart()"
                    (switchChange)="onSwitchChange($event.evt, $event.index)"
                    (finalizeProducts)="doFinalizeProducts()"
                >
                </app-ad-spend>
            </aw-wizard-step>

            <aw-wizard-step class="cart-wizard__step" [stepTitle]="'CHECKOUT' | translate" (stepEnter)="onStepEnter($event,CART_STEPS.Checkout)">
                <app-checkout *ngIf="activeCart.currentStep === CART_STEPS.Checkout"
                    [paymentForm]="paymentForm"
                    [campForm]="campForm"
                    [cartForm]="cartForm"
                    [product]="product"
                    [clientsData]="clientsData"
                    [selectedClient]="selectedClient"
                    [finalizedProducts]="finalizedProducts"
                    [cartStepData]="cartStepData"
                    [couponResponse]="couponResponse"
                    [addingFacebook]="addingFacebook"
                    [addingGoogle]="addingGoogle"
                    [addingConsulting]="addingConsulting"
                    [hasFacebook]="hasFacebook"
                    [hasGoogle]="hasGoogle"
                    [isAdmin]="isAdmin"
                    [isShopManager]="isShopManager"
                    [coupons]="coupons"
                    (previous)="onPrevious(CART_STEPS.Cart)"
                    (sendOrder)="placeOrder($event.cart, $event.coupon)"
                >
                </app-checkout>
            </aw-wizard-step>
        </form>
    </aw-wizard>
</div>
